var render = function render(){var _vm=this,_c=_vm._self._c;return _c('resource-action',{attrs:{"tag":_vm.tag,"promise":_vm.vacanciesPromise},on:{"success":_vm.handleSuccess,"error":_vm.handleError},scopedSlots:_vm._u([{key:"default",fn:function({ loading }){return [_vm._t("default",null,{"vacancies":_vm.vacancies,"loading":loading})]}}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }